import React from "react";
import { useEffect } from "react";
import MediaQuery from "react-responsive";
import { useDispatch, useSelector } from "react-redux";

import "../../../scss/fundraiser.scss";
import { MobileView } from "./MobileView";
import { DesktopView } from "./DesktopView";
import { Footer, Header } from "../../../components";
import { PAGENAME_CONSTANTS } from "../../../constants";
import Tracking from "../../../services/tracking.service";
import { fundRaiserPageAction } from "../../../store/actions";
import { FundraiserDetailPageSekeleton } from "../../../components/skeletons";

export function FundRaiserPage() {
    const dispatch = useDispatch();
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    let pageId = window.location.pathname.split("/");
    pageId = pageId[2];

    useEffect(() => {
        dispatch(fundRaiserPageAction.getFundRaiserPage(pageId));
    }, []);

    useEffect(() => {
        if (pageDetails) {
            dispatch(fundRaiserPageAction.getGoodLuckMessages({ fundraiser_page_id: pageDetails.id }));

            Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.FUNDRAISER, pageTitle: pageDetails.page_title,
                fundrasier_name: pageDetails.page_title,
                raised_amount: pageDetails.total_fund_raised,
                number_of_donation: pageDetails.count_donations,
                goal_amount: pageDetails.fundraising_goal
            })
}
    }, [pageDetails])

return <div className="fundraiser single-fund-raising">
    <Header />
    {(pageDetails ?
        <div className="page-main-area">

            {/* Desktop View */}
            <MediaQuery minDeviceWidth={991}>
                <DesktopView pageDetails={pageDetails} />
            </MediaQuery>

            {/* Mobile View */}
            <MediaQuery maxDeviceWidth={991}>
                <MobileView pageDetails={pageDetails} />
            </MediaQuery>

        </div>

        : <FundraiserDetailPageSekeleton />
    )}
    <Footer />
</div>
}